// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1431":"3f67c9b5","2818":"a3314246","5211":"3f67c9b5","7275":"3f67c9b5"}[chunkId] + ".chunk.css";
};